import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Favicon from "react-favicon";
import { Provider } from "react-redux";
import { store } from "./store/store";
import App from "./App";
import LogoDarkIcon from "./assets/brand/logoIcon.svg";
//Redux persist imports
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import "./scss/common.scss";
import "./scss/index.scss";

let persistor = persistStore(store);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <Favicon url={LogoDarkIcon} />
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>
);
